import { useEffect } from 'react';
import AWS from 'aws-sdk';

export const useActivityTracker = () => {
  const cloudwatchlogs = new AWS.CloudWatchLogs({
    region: process.env.REACT_APP_AWS_REGION,
    accessKeyId: process.env.REACT_APP_AWS_ACCESS_KEY,
    secretAccessKey: process.env.REACT_APP_AWS_SECRET_ACCESS_KEY
  });

  const logGroupName = '/tripleNet/frontend/activity';
  const logStreamName = `activity-${new Date().toISOString().split('T')[0]}`; // daily log stream

  // Ensure log group and stream exist
  const ensureLogStream = async () => {
    try {
      // Check if log group exists
      await cloudwatchlogs
        .createLogGroup({ logGroupName })
        .promise()
        .catch((err) => {
          if (err.code !== 'ResourceAlreadyExistsException') throw err;
        });

      // Check if log stream exists
      await cloudwatchlogs
        .createLogStream({ logGroupName, logStreamName })
        .promise()
        .catch((err) => {
          if (err.code !== 'ResourceAlreadyExistsException') throw err;
        });
    } catch (err) {
      console.error('Error ensuring log stream:', err);
    }
  };

  const trackEvent = async (eventName, properties = {}) => {
    try {
      await ensureLogStream();

      const message = JSON.stringify({
        eventName,
        properties,
        timestamp: new Date().toISOString()
      });

      // Get the sequence token if needed
      let nextToken;
      try {
        const streams = await cloudwatchlogs
          .describeLogStreams({
            logGroupName,
            logStreamNamePrefix: logStreamName
          })
          .promise();
        nextToken = streams.logStreams?.[0]?.uploadSequenceToken;
      } catch (err) {
        console.warn('Could not describe log streams:', err);
      }

      // Send the log event
      const params = {
        logEvents: [
          {
            message,
            timestamp: Date.now()
          }
        ],
        logGroupName,
        logStreamName,
        ...(nextToken && { sequenceToken: nextToken })
      };

      const data = await cloudwatchlogs.putLogEvents(params).promise();
      console.log('Log sent:', data);
    } catch (err) {
      console.error('Event logging failed:', err);
    }
  };

  return { trackEvent };
};
